var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-layout"},[_c('b-row',[_c('b-col',{staticClass:"main",attrs:{"cols":"12"}},[_vm._t("header")],2),_c('b-col',{staticClass:"body",staticStyle:{"border-top":"0px"},attrs:{"cols":"12"}},[_c('div',{style:({ height: _vm.height + 'px' })},[_vm._t("default"),_vm._t("body")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }